import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface ActiveClinicians {
  id: number;
  name: string;
}

export interface ActiveFacilities {
  id: number;
  name: string;
}

export interface TrainingProgress {
  id: number;
  name: string;
}

export interface TrainingType {
  id: number;
  name: string;
}

export interface FacilityClinicianMappingMetaData {
  activeClinicians: ActiveClinicians[];
  facilityList: ActiveFacilities[];
  trainingProgressList: TrainingProgress[];
  trainingTypeList: TrainingType[];
}
export interface FacilityClinicianMapping {
  id: number;
  facilityId: number;
  providerId: number;
  status: boolean;
  facilityAssignedEmail: string;
  primaryPhone: string;
  username: string;
  networkAccessId: string;
  emrId: string;
  vpnGatewayId: string;
  privilegesIssuedDate: string;
  mfaConfiguration: string;
  mfa: string;
  followUpContact: string;
  trainingProgress: number;
  trainingType: number;
  followUpRequired: boolean;
  providerFacilityNotes: string;
}

export interface FacilityClinicianMappingView {
  id: number;
  facilityId: number;
  providerId: number;
  facilityName: string;
  providerName: string;
  status: boolean;
  facilityAssignedEmail: string;
  primaryPhone: string;
  username: string;
  networkAccessId: string;
  emrId: string;
  vpnGatewayId: string;
  privilegesIssuedDate: string;
  mfaConfiguration: string;
  mfa: string;
  followUpContact: string;
  trainingProgress: string;
  trainingType: string;
  followUpRequired: boolean;
  providerFacilityNotes: string;
}

export const getFacilityClinicianMappingMetaData = async (
  userId: string,
  facilityId: number,
  clinicianId: number,
  mappingId: number,
  action: string
): Promise<FacilityClinicianMappingMetaData> => {
  const apiAction = action.toLowerCase() === 'save' ? 'SAVE' : 'UPDATE';
  const queryParams = [];
  if (facilityId !== 0) {
    queryParams.push(`facilityId=${facilityId}`);
  }
  if (clinicianId !== 0) {
    queryParams.push(`clinicianId=${clinicianId}`);
  }
  if (apiAction === 'UPDATE') {
    queryParams.push(`facilityClinicianMapId=${mappingId}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  const response = await httpRequest<FacilityClinicianMappingMetaData>({
    method: 'GET',
    url: `/operation/facility-clinician-map/metadata${queryString}&action=${apiAction}`,
    headers: { userId },
  });
  return response;
};

export const saveOrUpdateFacilityClinicianMapping = async (
  userId: string,
  action: string,
  payload: FacilityClinicianMapping
) => {
  const apiAction = action === 'Save' ? 'SAVE' : 'UPDATE';
  const response = await httpRequest<FacilityClinicianMapping>({
    method: 'PUT',
    url: `operation/facility-clinician-map?action=${apiAction}`,
    headers: { userId },
    data: payload,
  });
  return response;
};

export const getFacilityClinicianMappingDetailsById = async (
  userId: string,
  facilityClinicianMapId: number
): Promise<FacilityClinicianMapping> => {
  const response = await httpRequest<FacilityClinicianMapping>({
    method: 'GET',
    url: `/operation/facility-clinician-map?facilityClinicianMapId=${facilityClinicianMapId}`,
    headers: { userId },
  });
  return response;
};

export const getFacilityClinicianMappingDetailsForView = async (
  userId: string,
  facilityClinicianMapId: number
): Promise<FacilityClinicianMappingView> => {
  const response = await httpRequest<FacilityClinicianMappingView>({
    method: 'GET',
    url: `/operation/facility-clinician-map/view?facilityClinicianMapId=${facilityClinicianMapId}`,
    headers: { userId },
  });
  return response;
};
